import {
  FloatingFocusManager,
  useDismiss,
  useFloating,
  useInteractions,
} from "@floating-ui/react";
import { FloatingPortal } from "@floating-ui/react";
import { FloatingOverlay } from "@floating-ui/react";
import c from "classnames";
import { PropsWithChildren } from "react";

import { Card } from "@design-system/Card/Card";
import { ScrollBox } from "@design-system/ScrollBox/ScrollBox";

import classes from "./Modal.module.css";

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  placeItems?: string;
  fullHeight?: boolean;
  transitionDirection?: "bottom" | "right";
}>;

export const Modal = ({
  children,
  isOpen,
  onClose,
  placeItems = "center",
  fullHeight = false,
  transitionDirection = "bottom",
}: Props) => {
  const { context } = useFloating({
    open: isOpen,
    onOpenChange: onClose,
  });

  const dismiss = useDismiss(context, { outsidePressEvent: "mousedown" });

  const { getFloatingProps } = useInteractions([dismiss]);

  return (
    <FloatingPortal>
      <FloatingOverlay
        className={c(classes.overlay, isOpen && classes.open)}
        style={{ placeItems }}
      >
        <FloatingFocusManager context={context}>
          <div
            className={c(
              classes.container,
              classes[transitionDirection],
              fullHeight && classes.fullHeight,
            )}
            {...getFloatingProps()}
          >
            <Card>
              <div className={classes.handleContainer}>
                <div className={classes.handle} />
              </div>
              {children}
            </Card>
          </div>
        </FloatingFocusManager>
      </FloatingOverlay>
    </FloatingPortal>
  );
};

Modal.Header = Card.Header;
Modal.Header.Actions = Card.Header.Actions;
Modal.Header.Title = Card.Header.Title;
Modal.Body = Card.Body;
Modal.Footer = Card.Footer;
Modal.ScrollBox = ScrollBox;
